export default "__VITE_ASSET__BrkHKuOp__$_?react__"